import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PropTypes from "prop-types";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
export default function FolderListItem({
  handleFileSelect,
  selectedFile,
  id,
  name,
}) {
  return (
    <ListItem key={id} style={{ paddingTop: 0, paddingBottom: 0 }}>
      <ListItemButton onClick={handleFileSelect} id={id}>
        <ListItemIcon>
          <InsertDriveFileIcon />
        </ListItemIcon>
        <ListItemText primary={name} />
        {selectedFile.id === id ? (
          <RadioButtonCheckedIcon />
        ) : (
          <RadioButtonUncheckedIcon />
        )}
      </ListItemButton>
    </ListItem>
  );
}

FolderListItem.propTypes = {
  handleFileSelect: PropTypes.func,
  selectedFile: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
